import { Share2 } from "lucide-react";
import { shareLink } from "@/lib/share";

export function ShareButton({ title, url = "", note = "", label = "Share", className = "", testid = "share-btn" }) {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    shareLink({ title, url, note });
  };
  return (
    <button onClick={onClick} data-testid={testid}
      className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest transition-colors ${className}`}>
      <Share2 className="h-4 w-4" /> {label}
    </button>
  );
}
